<template>
    <div v-if="show || image" class="theme-image-picker">
        <div
            :id="id"
            :class="{
                'image-selection overflow-hidden': true,
                'is-loading': uploadingImage
            }"
            :style="`color:${color};border-color:${borderColor};border-style:${borderStyle};border-width:${borderWidth};`"
        >
            <div
                v-if="image"
                v-tippy="{
                    onShow: () => !isGif,
                    placement: 'top-center',
                    arrow: true,
                    arrowType: 'round',
                    animation: 'fade'
                }"
                @click="openUploadMedia(true)"
                :content="$t('setting_popup_edit_crop')"
                :style="{ 'background-image': `url(${image})`, filter: `blur(${blur}px)`, opacity: `${opacity}%` }"
                class="image w-full h-full absolute bg-cover rounded-full"
            ></div>

            <div v-else @click="openUploadMedia()" style="width: 35px; height: 35px; border-radius: 100%"></div>
        </div>
        <template v-if="showTool && image">
            <div class="remove-image-icon absolute cursor-pointer" @click="removeImage()">
                <i class="fas fa-times-circle text-black text-xl"></i>
            </div>
        </template>
    </div>
</template>

<script>
import quizImagePickerMixin from '@/mixins/quiz-image-picker'

export default {
    mixins: [quizImagePickerMixin],

    props: {
        alreadyShow: {
            type: Boolean,
            default: false
        },

        id: {
            type: String,
            default: null
        },

        title: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: '#000'
        },

        borderColor: {
            type: String,
            default: '#000'
        },

        borderStyle: {
            type: String,
            default: 'solid'
        },

        borderWidth: {
            type: String,
            default: '2px'
        },

        questionIndex: {
            type: Number,
            default: null
        },

        answerIndex: {
            type: Number,
            default: null
        },

        location: {
            type: String,
            defauld: ''
        },

        image: {
            type: String,
            default: null
        },

        imageOriginal: {
            type: String,
            default: null
        },

        imageSource: {
            type: String,
            default: null
        },

        imageCoordinates: {
            type: [Object, Array, String],
            default: null
        },

        blur: {
            type: [String, Number],
            default: 0
        },

        darken: {
            type: [String, Number],
            default: 0
        },

        opacity: {
            type: [String, Number],
            default: 100
        },

        showTool: {
            type: Boolean,
            default: true
        },

        placeholder: {
            type: String,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.theme-image-picker {
    width: 35px;
    height: 35px;
    position: relative;
    align-self: flex-start;

    .image-selection {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 100%;
    }

    .remove-image-icon {
        top: -11px;
        right: -11px;
    }

    .is-loading::after {
        border-radius: 100%;
    }

    .is-loading::before {
        top: calc(50% - 18px);
        left: calc(50% - 18px);
    }
}
</style>
